export const BUTTON_COLORS = ['brand-primary', 'brand-secondary', 'white', 'gray', 'destructive'] as const;

export type ButtonColor = (typeof BUTTON_COLORS)[number];
